export default "__VITE_ASSET__lbVAgF1B__"